import React from 'react'
import './index.scss'

export const Empty = () => {
  return (
    <div className="empty-data">
      <span className="empty-data__image"></span>
      <p>暂无数据</p>
    </div>
  )
}
